import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { List } from 'immutable'
import { setSelectedOtherFilters } from 'reducers/managementUI/reducer'
import { SelectedOtherFilter } from 'types/managementUI.types'
import {
  FILTER_TYPE_MEDIA,
  MANAGEMENT_UI_OTHER_FILTERS,
  MANAGEMENT_UI_SCHEDULING_FILTERS,
} from 'constants/managementUI'
import { MANAGEMENT_UI_SCHEDULING } from 'constants/index'
import Menu from 'components/common/Menu'
import messages from '../../translate'
import { OtherFiltersDropdownProps } from './OtherFiltersDropdown.types'

export const OtherFiltersDropdown = ({
  intl: { formatMessage },
  selectedOtherFilters,
  setSelectedOtherFilters,
  applyFilter,
  anchorEl,
  setAnchorEl,
  activeTab,
  closeOnSelect = false,
}: WrappedComponentProps & OtherFiltersDropdownProps) => {
  const selectedOtherFiltersData = selectedOtherFilters.toJS()

  const updatedFilters = useMemo(
    () =>
      MANAGEMENT_UI_OTHER_FILTERS.filter(
        ({ value }) =>
          !selectedOtherFiltersData.find(
            ({ value: selectedValue }: SelectedOtherFilter) =>
              selectedValue === value,
          ) &&
          (activeTab !== MANAGEMENT_UI_SCHEDULING ||
            MANAGEMENT_UI_SCHEDULING_FILTERS.includes(value)),
      ),
    [JSON.stringify(selectedOtherFiltersData), activeTab],
  )

  return (
    <Menu
      anchorEl={anchorEl}
      onClick={menuItem => {
        const { value } = menuItem
        setSelectedOtherFilters([...selectedOtherFiltersData, menuItem])

        if (value === FILTER_TYPE_MEDIA) {
          applyFilter({
            [FILTER_TYPE_MEDIA]: true,
          })
        }

        if (closeOnSelect) {
          setAnchorEl(null)
        }
      }}
      setAnchorEl={setAnchorEl}
      closeOnSelect={closeOnSelect}
      menuItems={updatedFilters}
      title={formatMessage(messages.addFilter)}
      getFormatMessage={label =>
        formatMessage(messages[label as keyof typeof messages])
      }
    />
  )
}

export default connect(
  (state: { getIn: (path: Array<string>) => List<SelectedOtherFilter> }) => ({
    selectedOtherFilters: state.getIn(['managementUI', 'selectedOtherFilters']),
  }),
  { setSelectedOtherFilters },
)(injectIntl(OtherFiltersDropdown))
